'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/yearsFromNow.js
// module id = 231
// module chunks = 0